import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueAxios from 'vue-axios'
import Axios from 'axios'
import interceptorsRequest from './components/interceptorsRequest'
import interceptorsResponse from './components/interceptorsResponse'
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(VueAxios, Axios)


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import Toast from "vue-toastification";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
interceptorsRequest();
interceptorsResponse(router);

Vue.use(Toast);
Vue.use(VueGoogleMaps, {
  load: {
    //key: "AIzaSyAzaRnAxSF8hxFNvOglaPf1nLXFBANYngM",
    key: "AIzaSyAHaL0Gi8Pj7mCUCJ2RPk9VZQLKM0GAUls",
    libraries: "", // necessary for places input
  },
});

//Descomentar si quiere utilizar base local
//Axios.defaults.baseURL = 'http://localhost:8080';

//Axios.defaults.baseURL = 'http://20.226.15.210:8084';
//Axios.defaults.baseURL = 'http://20.226.15.210:8082';
//Descomentar si quiere utilizar base local
Axios.defaults.baseURL = 'https://login.resto-up.com/api';
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

